import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalOptions, Modal, ModalController, ToastController, ActionSheetController } from 'ionic-angular';
import { Sadhona } from '../../providers/sadhona'
import { ViewReadSadhanaPage } from '../view-read-sadhana/view-read-sadhana'
import { GlobalVariable } from '../../global';
import { HomePage } from '../home/home';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the MentorApproveSadhanaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-mentor-approve-sadhana',
  templateUrl: 'mentor-approve-sadhana.html',
})
export class MentorApproveSadhanaPage {
  sadhanaData: any
  usertype: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private sadhona: Sadhona, private alertCtrl: AlertController,
    private modal: ModalController, private toastCtrl: ToastController, private actionSheetCtrl: ActionSheetController,
    private storage: Storage) {
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      if (this.usertype != GlobalVariable.Mentor) {
        this.navCtrl.setRoot(HomePage);
      }
    });
  }

  ionViewDidLoad() {
    this.submittedSadhanaData()
  }

  submittedSadhanaData() {
    this.sadhona.submittedSadhanaDataByMentor().subscribe(
      res => {
        this.sadhanaData = res['data']
      },
      err => {
        this.presentAlert('Alert Message', 'something went wrong ,try again')
      }
    )
  }

  presentAlert(title, msg) {

    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: [{
        text: 'Dismiss',
      }],
    });
    alert.present();
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  viewSadhana(item) {
    this.navCtrl.push(ViewReadSadhanaPage, {
      userid: item.userid,
      month: item.sadhanamonth,
      year: item.sadhanayear,
      sequencenumber: item.sequencenumber,
      item: item
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/mentor-approve-sadhana/mentor-approve-sadhana.ts